import { ChannelHoursView } from '@/features/opening-hours/components/ChannelHoursView';

export default function ReservationHoursPage() {
  return <ChannelHoursView service="RESERVATION" />;
}
